import {useContext, useState} from "react";
import {GlobalContext} from "../../GlobalReducer";
import {getRequestCreateOrderParams} from "../checkout/utils/Context";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {requestLogs, getLatestUid} from "../../utils/HttpClient";

export default function TechInfo() {
    // eslint-disable-next-line
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());

    const toggleRow = (index: number) => {
        const newExpanded = new Set(expandedRows);
        if (newExpanded.has(index)) {
            newExpanded.delete(index);
        } else {
            newExpanded.add(index);
        }
        setExpandedRows(newExpanded);
    };

    return (
        <div className="card mt-4">
            <div className="card-body pb-4">
                <div className={'card card-internal mt-2'}>
                    <div className="card-body">
                        <h5><b>Latest UID:</b> {getLatestUid() || 'No UID yet'}</h5>
                    </div>
                </div>

                <div className={'card card-internal mt-2'}>
                    <div className="card-body">
                        <h5>Request Logs</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th>Timestamp</th>
                                        <th>Container</th>
                                        <th>URL</th>
                                        <th>Status</th>
                                        <th>Execution Time (ms)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {requestLogs.map((log, index) => (
                                        <>
                                            <tr key={index}>
                                                <td>{new Date(log.timestamp).toLocaleString()}</td>
                                                <td>{log.container}</td>
                                                <td
                                                    onClick={() => toggleRow(index)}
                                                    style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    {log.url} {expandedRows.has(index) ? '▼' : '▶'}
                                                </td>
                                                <td>{log.status}</td>
                                                <td>{log.executionTime}</td>
                                            </tr>
                                            {expandedRows.has(index) && (
                                                <tr key={`${index}-params`}>
                                                    <td colSpan={5} style={{ backgroundColor: '#f8f9fa', padding: '10px' }}>
                                                        <strong>Params:</strong>
                                                        <pre style={{ margin: '5px 0 0 0', fontSize: '0.85em', whiteSpace: 'pre-wrap' }}>
                                                            {JSON.stringify(log.params, null, 2)}
                                                        </pre>
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/*<div className={'card card-internal mt-2'}>*/}
                {/*    <div className="card-body">*/}
                {/*        <div className="row">*/}
                {/*            <div className="col-12 overflow-auto" style={{'height' : '400px'}}>*/}
                {/*                <pre style={{ border: '1px solid #DDDDDD'}}>{JSON.stringify(state, null, 2)}</pre>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>)
}